var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('div',{staticClass:"ppt pptdisablearea",attrs:{"id":"pptContainer"}},[_c('img',{staticClass:"teacherppt flex1",attrs:{"src":_vm.Fn.hashToUrl(_vm.url)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }